<template>
  <CContainer fluid>
    <FloatingActionButton 
      :menuItems="menu" 
      :userRoles="userRoles" 
      :userPermissions="userPermissions" 
      :context="{ rootPath }" />

    <h3>Oportunidades</h3>
    <CCard class="mt-4">
      <CCardBody>
        <CRow>
          <CCol col="sm-6" sm="6">
            <CInput 
              label="Buscar:" 
              :value.sync="searchWord" 
              @keyup.enter="getData(1, searchWord)">
              <template #prepend-content>
                <a href="#" @click="getData(1)">
                  <i class="bi bi-arrow-clockwise"></i>
                </a>
              </template>
              <template #append-content>
                <a href="#" @click="getData(1, searchWord)">
                  <i class="bi bi-search"></i>
                </a>
              </template>
            </CInput>
          </CCol>
          <!-- <CCol col="sm-6" sm="6">
            <CButton 
              color="success" 
              class="mt-4"
              :to="`${rootPath}/agregar`">
              <i class="bi bi-plus-circle h5 align-middle mr-2"></i>
              <span>Agregar</span>
            </CButton>
            <CButton v-if="this.$store.state.user.data.tipo_Empleado === 'A'"
              color="primary"
              variant="outline"
              class="mt-4 ml-2"
              @click="showPanelFilters=true">
              <i class="bi bi-funnel h5 align-middle mr-2"></i>
              <span>Filtros</span>
            </CButton>
            <CButton v-if="this.$store.state.user.data.tipo_Empleado === 'A' && isFiltered"
              color="danger"
              variant="outline"
              class="mt-4 ml-2"
              @click="e => ClearFilters(e)">
              <CIcon name="cil-filter-x" class="mr-2" />
              <span class="align-middle">Quitar Filtros</span>
            </CButton>
          </CCol> -->
        </CRow>
        <CDataTable 
          hover
          class="table-hover-icons"
          :responsive=true
          :fields="fields" 
          :items="opportunities"
          :noItemsView="{ noItems: '' }"
          :items-per-page="itemsPerPage">
          <template #empresa="{ item }">
            <td>
              <h4>{{ item.empresa }}</h4>
              <div>
                <i class="bi bi-postcard mr-1"></i>
                <span>{{ item.identificacion }}</span>
              </div>
              <div>
                <i class="bi bi-person-workspace mr-1" />
                <span>{{ item.empleado }}</span>
              </div>
            </td>
          </template>
          <template #clasificacion="{item}">
            <td>
              <div>
                <span>{{ item.origen_Oportunidad }}</span>
              </div>
              <div>
                <span>{{ item.grupo_Oportunidad }}</span>
              </div>
              <div>
                <span>{{ item.fase_Venta }}</span>
              </div>
            </td>
          </template>
          <template #prioridad="{item}">
            <td>
              <div>
                <i class="bi bi-cash-coin mr-1" />
                <strong>{{ formatter.format(item.valor_NegocioPrevisto) }}</strong>
              </div>
              <div>
                <i class="bi bi-calendar3 mr-1"></i>
                <span>{{ moment(item.fecha_Creacion).format("DD/MM/YYYY") }}</span>
              </div>
              <div>
                <CBadge :color="getColor(item.prioridad)" v-if="item.prioridad">
                  {{ opportunityStatus[item.prioridad] }}
                </CBadge>
              </div>
            </td>
          </template>
          <template #acciones="{item}">
            <td class="d-flex">
              <div class="hover-actions">
                <!-- <a href="#" 
                  v-c-tooltip="'Editar'"
                  @click="() => {
                    $router.push({ path: `${rootPath}/editar/${item.id_Directorio}` });
                  }">
                  <CIcon name="cil-pencil" size="lg" class="text-warning hover-icon mr-2"/>
                </a> -->
                <a href="#" 
                  v-c-tooltip="'Eliminar'"
                  @click="(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                  }">
                  <i class="bi bi-trash text-danger h4 hover-icon mr-2"></i>
                </a>
                <a href="#"
                  v-c-tooltip="'Agregar Seguimiento'"
                  @click="(e) => {
                    e.stopPropagation();
                    e.preventDefault();

                    showPanelTracking = true;
                    selectedOpportunityId = item.id_Oportunidad;
                    updateComponentOpportunityTracking +=1;
                  }">
                  <i class="bi bi-search-heart text-success h4 hover-icon mr-2"></i>
                </a>                
                <a href="#"
                  v-c-tooltip="'Seguimientos'"
                  @click="event => {
                    event.stopPropagation();
                    event.preventDefault();
  
                    showPanelOpportunityTracking = true;
                    selectedOpportunityId = item.id_Oportunidad;
                    updateComponentOpportunityTracking +=1;
                  }">
                  <i class="bi bi-tags text-dark h4 hover-icon mr-2"></i>
                </a>                
              </div>

              <a href="#"
                @click="toggleDocument($event, item)" >
                <CIcon class="text-dark" :name="item._toggled ? 'cil-chevron-circle-up-alt' : 'cil-chevron-circle-down-alt'" />
              </a>
            </td>
          </template>
          <template #details="{item}">
            <CCollapse class="my-3" :show="item._toggled">
              <div class="d-flex justify-content-end">
                <!-- <a href="#" 
                  class="mr-3"
                  @click="event => openRightSideBar(event, item)">
                  <i class="bi bi-check2-circle h5"></i>
                  <i class="bi bi-arrow-left-right h5"></i>
                </a> -->
              </div>
              <CRow>
                <div class="ml-4">
                  <strong>Descripción:</strong>
                  <p class="mx-4">
                    {{item.descripcion}}
                  </p>
                </div>
                <div class="ml-4">
                  <strong>Observaciones:</strong>
                  <p>
                    {{ item.observaciones }}
                  </p>
                </div>
              </CRow>
            </CCollapse>
          </template>
        </CDataTable>
        <CPagination 
          size="sm"
          class="d-flex justify-content-center"
          :activePage.sync="page" 
          :pages="pageCount" 
          @update:activePage="(value, a) => getData(value, searchWord)" />
        </CCardBody>

        <LoadingCover v-show="loading" />
    </CCard>

    <!-- Panel sidebar para filtros del datagrid -->
    <RightSideBar size="md" class="bg-s3grey" :show="showPanelFilters">
      <CContainer>
        <CCard class="mt-3">
          <CCardHeader>
            <CCardTitle>
              <h4>Seguimiento</h4>
            </CCardTitle>
          </CCardHeader>
          <CCardBody>
            <VerticalDynamicForm :fields="filter_fields" />
          </CCardBody>
          <CCardFooter>
            <div class="d-flex justify-content-center">
              <CButton 
                color="primary"
                class="mr-2"
                :class="isValidFilters ? '' : 'disabled'" 
                :disabled="!isValidFilters"
                @click="e => {
                  e.stopPropagation();
                  e.preventDefault();

                  showPanelFilters = false;
                  getData(1);
                }">
                <CIcon name="cil-check-circle" class="mr-2" />
                <span class="align-middle">Filtrar</span>
              </CButton>

              <CButton v-if="isFiltered"
                color="danger"
                variant="outline"
                class="mr-2"
                @click="e => ClearFilters(e)">
                <CIcon name="cil-filter-x" class="mr-2" />
                <span class="align-middle">Quitar Filtros</span>
              </CButton>

              <CButton 
                color="secondary"
                variant="outline"
                @click="e => {
                  e.stopPropagation();
                  e.preventDefault();

                  showPanelFilters = false;
                }">
                <CIcon name="cil-x-circle" class="mr-2" />
                <span class="align-middle">Cancelar</span>
              </CButton>
            </div>
          </CCardFooter>
        </CCard>
      </CContainer>
    </RightSideBar>

    <!-- Panel sidebar para formulario de seguimiento -->
    <RightSideBar size="md" class="bg-s3grey" :show="showPanelTracking">
      <FormTracking 
        title="Agregar Seguimiento" 
        :opportunityId="selectedOpportunityId"
        :key="updateComponentOpportunityTracking" 
        @closeWindow="ClosePanelTracking"/>
    </RightSideBar>

    <!-- Panel sidebar para gridlist de seguimientos -->
    <RightSideBar size="lg" class="bg-s3grey" :show="showPanelOpportunityTracking">
      <CContainer>
        <CCard class="mt-3">
          <CCardHeader>
            <CCardTitle>
              <h4>Seguimientos de Oportunidad</h4>
            </CCardTitle>
          </CCardHeader>
          <CCardBody>
            <BusinessTracking 
              :opportunityId="selectedOpportunityId"
              :key="updateComponentOpportunityTracking" />
          </CCardBody>
          <CCardFooter>
            <div class="d-flex justify-content-center">
              <CButton 
                color="dark" 
                class="mr-2 d-inline-block" 
                @click="e => {
                  e.stopPropagation();
                  e.preventDefault();

                  showPanelOpportunityTracking = false;
                }">
                <CIcon name="cil-x-circle" class="mr-2" />
                <span class="align-middle">Cerrar</span>
              </CButton>
            </div>
          </CCardFooter>
        </CCard>
      </CContainer>
    </RightSideBar>
  </CContainer>
</template>

<style scoped>
  @import "../../../../assets/css/table-hover-actions.css";
</style>

<script>
  import { ref } from "vue";
  import moment from "moment";
  
  import LoadingCover from "@/components/containers/LoadingCover.vue";
  import RightSideBar from "@/components/containers/RightSideBar.vue";
  import VerticalDynamicForm from "@/components/containers/VerticalDynamicForm.vue";
  import FloatingActionButton from "@/components/containers/FloatingActionButton.vue";
  import FormTracking from "@/components/forms/FormTracking.vue";
  import BusinessTracking from "@/components/datagrids/BusinessTracking.vue";

  import { 
    errorMessage,
    formatter
  } from "@/general"
  import { 
    dataGridOportunidades,
    dataListCampanias,
    dataListOrigenesOportunidades,
    dataListGruposOportunidades,
    dataListFasesVentas
  } from "@/api"
  import { 
    searchPersonal,
    searchDirectorio 
  } from "@/apiDataSearch";

  const fields = [
    { 
      key: 'empresa', 
      label: 'Empresa', 
      _style:'text-align:center;'
    },
    { 
      key: 'clasificacion', 
      label: 'Clasificación', 
      _style:'text-align:center;'
    },
    { 
      key: "prioridad",
      label: "Prioridad",
      _style:"text-align:center;"
    },
    { 
      key: "acciones", 
      label: ""
    },
  ]

  export default {
    data() {
      const self = this
      return {
        formatter,
        fields,
        loading: false,
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: "",
        // now: moment(),
        updateComponentOpportunityTracking: 0,
        showPanelFilters: null,
        showPanelTracking: null,
        showPanelOpportunityTracking: null,
        isFiltered: false,
        userRoles: [],
        userPermissions: [],
        menu: [
          {
            label: "Agregar",
            icon: 'bi bi-plus-circle',
            type: "success",
            route: (ctx) => `${ctx.rootPath}/agregar`
          },
          {
            label: "Filtros",
            icon: "bi bi-funnel",
            type: "primary",
            action: () => {
              self.showPanelFilters = true;
            }
          },
          {
            label: "Exportar Excel",
            icon: "bi bi-file-earmark-excel",
            // color: "#036369",
            type: "s3orange",
            action: () => {
              alert("Action ejecutada alert");
              self.testAction("Juanita");
            }
          }
        ],
        opportunities: [],
        opportunityStatus: {
          'M': 'Muy Importante',
          'I': 'Importante',
          'B': 'Baja'
        },
        selectedOpportunityId: "",
        selectedOpportunity: {},
        filter_fields: [
          {
            key: "personal",
            label: "Comercial",
            value: "",
            type: "autocomplete",
            options: [],
            prepend_content: {
              name: "person-badge"
            },
            update_search(value) {
              self.searchEmployee(value);
            }
          },
          {
            key: "Id_Directorio",
            label: "Cliente",
            value: "",
            type: "autocomplete",
            options: [],
            prepend_content: {
              name: "postcard"
            },
            update_search(value) {
              self.searchDirectory(value);
            }
          },
          {
            key: "Id_Campania",
            label: "Campaña",
            value: "",
            type: "select",
            options: [],
            prepend_content: {
              name: "rocket-takeoff"
            }
          },
          {
            key: "Id_OrigenOportunidad",
            label: "Origen Oportunidad",
            value: "",
            type: "select",
            options: [],
            prepend_content: {
              name: "postcard"
            }
          },
          {
            key: "Id_GrupoOportunidad",
            label: "Grupo Oportunidad",
            value: "",
            type: "select",
            options: [],
            prepend_content: {
              name: "postcard"
            }
          },
          {
            key: "Id_FaseVenta",
            label: "Fase Venta",
            value: "",
            type: "select",
            options: [],
            prepend_content: {
              name: "postcard"
            }
          }
        ]
      }
    },
    components: {
      LoadingCover,
      RightSideBar,
      VerticalDynamicForm,
      FloatingActionButton,
      FormTracking,
      BusinessTracking
    },
    methods: {
      moment,
      async getData(page, search) {
        this.loading = true;
        this.searchWord = search;

        // let idStaffGroup;
        let idEmployee;

        // // ToDo
        // if (this.$store.state.user.data.tipo_Empleado === "D") {
        //   idStaffGroup = this.$store.state.user.data.id_GrupoPersonal;
        // } else {
        //   idStaffGroup = this.filter_fields[0].value === "" ? null : this.filter_fields[0].value
        // }

        if (this.$store.state.user.data.tipo_Empleado === "V") {
          idEmployee = this.$store.state.user.data.id_Empleado;
        } else {
          idEmployee = this.filter_fields[0].value === "" ? null : this.filter_fields[0].value
        }

        let filters = {
          "Id_Personal": idEmployee
        };

        this.filter_fields.forEach(field => {
          if (field.key === "personal") {
            return;
          }

          if (field.value.length > 0) {
            filters[field.key] = field.value;
          }
        });

        try {
          const { count, results } = await dataGridOportunidades(this, page, search, filters);
          
          this.pageCount = parseInt(count / this.itemsPerPage)
          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++
          }
          this.opportunities = results;

          this.ValidDataFiltered();          
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: errorMessage(error),
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      async searchEmployee(value) {
        try {
          const filter = { "tipo": "vendedores" }
          const response = await searchPersonal(this, value, filter);

          this.filter_fields[0].options = response.map((item) => {
            return {
              value: item.id_Personal,
              label: item.nombre_Empleado
            }
          });
        } catch (error) {
          console.log(error);
          
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al cargar los datos de Personal!",
            show: 5
          });
        }
      },
      async searchDirectory(value) {
        if (value.length > 2) {
          try {
            const response = await searchDirectorio(this, value);

            this.filter_fields[1].options = response.map(item => {
              return {
                value: item.id_Directorio,
                label: `${item.empresa} - ${item.identificacion}`
              }
            });
          } catch(error) {
            console.log(error);
            
            this.$store.commit("setAlert", {
              color: "danger",
              message: "Error al cargar los datos de Directorio!",
              show: 5
            });
          }
        }
      },
      async getCampaigns() {
        try {
          const response = await dataListCampanias(this);

          this.filter_fields[2].options = [
            {
              value: "",
              label: "Seleccionar"
            },
            ...response.map((item) => {
              return {
                value: item.id_Campania,
                label: item.nombre_Campania
              }
            })
          ]
        } catch (error) {
          console.log(error);
          
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al cargar los datos de Campañas!",
            show: 5
          });
        }
      },
      async getOriginsOpportunity() {
        try {
          const response = await dataListOrigenesOportunidades(this);

          this.filter_fields[3].options = [
            {
              value: "",
              label: "Seleccionar"
            },
            ...response.map(item => { 
              return {
                value: item.id_OrigenOportunidad, 
                label: item.origen_Oportunidad
              }
            })
          ]
        } catch (error) {
          console.log(error)
        }
      },
      async getOpportunityGroups() {
        try {
          const response = await dataListGruposOportunidades(this);

          this.filter_fields[4].options = [
            {
              value: "",
              label: "Seleccionar"
            },
            ...response.map(item => { 
              return {
                value: item.id_GrupoOportunidad, 
                label: item.grupo_Oportunidad
              }
            })
          ]
        } catch (error) {
          console.log(error)
        }
      },
      async getSellPhases() {
        try {
          const response = await dataListFasesVentas(this);

          this.filter_fields[5].options = [
            {
              value: "",
              label: "Seleccionar"
            },
            ...response.map(item => { 
              return {
                value: item.id_FaseVenta, 
                label: item.fase_Venta 
              }
            })
          ]
        } catch (error) {
          console.log(error)
        }
      },
      openPanelTracking(e, opportunityId) {
        e.stopPropagation();
        e.preventDefault();

        this.selectedOpportunityId = opportunityId;
        this.showPanelTracking = true;
      },
      toggleDocument(e, item){
        e.stopPropagation()
        this.$set(item, '_toggled', !item._toggled)
        this.$nextTick(() => { })
      },
      getColor(status) {
        if(status === 'M') return 'success'
        if(status === 'I') return 'warning'
        if(status === 'B') return 'default'
      },
      ValidDataFiltered() {
        this.isFiltered = false;

        this.filter_fields.forEach(field => {
          if (field.value.length > 0) {
            this.isFiltered = true;
          }
        });
      },
      ClearFilters() {
        this.showPanelFilters = false;

        this.filter_fields.forEach(field => {
          field.value = "";

          if (field.type === "autocomplete") {
            field.options = [];
          }
        });

        this.getData(1);
      },
      ClosePanelTracking() {
        this.showPanelTracking = false;
      }
    },
    computed: {
      isValidForm() {
        return this.trackingdocs_fields.every(field => {
          if(field.required) {
            // if(field.key === "dateTracking" || field.key === "timeTracking") {
            //   return this.now.isSameOrBefore(`${this.trackingdocs_fields[1].value}T${this.trackingdocs_fields[2].value}`, 'minutes')
            // }
            if(typeof field.value === "string") {
              return field.value.length > 0
            }

            return field.value > 0
          }

          return true;
        })
      },
      isValidFilters() {
        let isValid = false;

        this.filter_fields.forEach(field => {
          if (field.value.length > 0) {
            isValid = true
          }
        });

        return isValid;
      }
    },
    setup() {
      const rootPath = ref("");

      return {
        rootPath
      }
    },
    created() {
      console.log("Created");
      
      this.rootPath = this.$router.currentRoute.fullPath;

      this.getData();
    },
    mounted() {
      console.log("Mounted");
      
      // this.rootPath = this.$router.currentRoute.fullPath;

      this.getCampaigns();
      this.getOriginsOpportunity();
      this.getOpportunityGroups();
      this.getSellPhases();
    }
  }
</script>
